module.exports = __webpack_public_path__ + "img/sf.adacb954.svg";